import styled from 'styled-components';

import FadeIn from '@/components/animations/FadeIn';

export const StyledFade = styled(FadeIn as any)`
	display: flex;
	flex-direction: column;
	height: 100%;
	overflow: hidden;
	width: 100%;
	align-items: flex-start;
`;

export const StyledCourseContainer = styled.div`
	display: flex;
	height: 100%;
	overflow: hidden;
	width: 100%;

	.course-content {
		display: grid;
		flex-basis: 100%;
		flex-grow: 0;
		grid-template-rows: auto auto 1fr;
		/* Extra right margin leaves a gutter for the editor's floating comment icon */
		margin-right: var(--spacing-2);
	}

	.comment-panel {
		flex-basis: 275px;
		flex-shrink: 0;
		overflow: auto;
		padding: var(--spacing-4) var(--spacing-2);
	}

	@media (max-width: 767px) {
		.course-content {
			margin-right: 0;
		}
	}
`;

export const StyledFooterBody = styled.div`
	border-top: 1px solid rgb(50 50 50 / 10%);
	display: flex;
	margin-top: auto;
	padding-top: var(--spacing-4);
	position: relative;
	text-align: right;
	width: 100%;

	> button {
		align-self: flex-end;
	}
	.actions-container {
		align-items: flex-end;
		display: flex;
		button {
			margin-right: var(--spacing-4);
		}
	}

	@media (max-width: 640px) {
		flex-wrap: wrap;
		gap: var(--spacing-2);
		padding-bottom: var(--spacing-4);
	}
`;
